import { ASSET_IMAGE_FILE_NAME_REGEX, imageType } from 'static/Constants';

export const isValidUpcGtinImageFilename = (file) => {
  const [fileName, fileExtension] = file?.toLowerCase().split('.');
  const isImageType = imageType.includes(fileExtension?.toLowerCase());

  const isMatchedFileName = ASSET_IMAGE_FILE_NAME_REGEX.test(
    fileName?.trim()?.toUpperCase()
  );

  return isImageType && isMatchedFileName;
};
